<template>
  <div>
    <header-bar>YouTubeマネタイズ</header-bar>
    <div v-if="modalVideoId === null">
      <div class="page-block">
        <div class="page-block__heading page-block__heading--withbar">
          <h3 class="page-block__title">申し立て動画検索</h3>
        </div>
        <div class="page-block__inner">
          <div
            class="radio"
            style="display: flex">
            <label for="search_by_video_id">
              <input
                id="search_by_video_id"
                v-model="type"
                type="radio"
                :value="1"
                name="search_by">
              <div class="option-input"></div>動画ID検索
            </label>
            <label
              for="search_by_assets"
              style="margin-left: 20px">
              <input
                id="search_by_assets"
                v-model="type"
                type="radio"
                :value="2"
                name="search_by">
              <div class="option-input"></div>アセット検索
            </label>
          </div>
          <div v-if="type === 1">
            <video-search
              :input-video-id="videoId"
              @change="onChangeVideoId"
              @row-clicked="onClaimRowClicked" />
          </div>
          <div v-else-if="type === 2">
            <asset-search
              :input-keyword="keyword"
              :input-asset-id="assetId"
              :default-page-index="pageIndex"
              @change="onChangeKeyword"
              @select-asset="onSelectAsset"
              @row-clicked="onClaimRowClicked"
              @change-pagination="onChangePagination" />
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="modalVideoId !== null">
      <claim-detail
        :video-id="modalVideoId"
        @closed="onDetailClosed" />
    </div>
  </div>
</template>

<script>
import HeaderBar from '../../../HeaderBar'
import YouTubeClaimsClaimDetail from './ClaimDetail'
import YouTubeClaimsVideoSearch from './VideoSearch'
import YouTubeClaimsAssetSearch from './AssetSearch'

export default {
  name: 'YouTubeClaimsIndex',
  components: {
    HeaderBar,
    ClaimDetail: YouTubeClaimsClaimDetail,
    VideoSearch: YouTubeClaimsVideoSearch,
    AssetSearch: YouTubeClaimsAssetSearch,
  },
  data() {
    return {
      type: 1,
      videoId: null,
      keyword: '',
      assetId: null,
      modalVideoId: null,
      pageToken: null,
      pageIndex: 0,
      error: null,
      errorMessage: null,
    }
  },
  watch: {
    type: {
      immediate: false,
      handler(value) {
        const query = { ...this.$route.query }
        query.type = value
        if (value === 1) {
          delete query.asset_id
          delete query.keyword
          delete query.page_index
          // delete query.page_token
          this.assetId = null
          this.keyword = ''
          this.pageIndex = 0
          // this.pageToken = ''
        } else {
          delete query.video_id
          this.videoId = null
        }
        this.$router.replace({ name: 'youtube-claims-search-index', query }, () => {})
      },
    },
  },
  mounted() {
    if (this.$route.query.type) {
      this.type = parseInt(this.$route.query.type, 10)
    }
    if (this.$route.query.video_id) {
      this.videoId = this.$route.query.video_id
    }
    if (this.$route.query.modal_video_id) {
      this.modalVideoId = this.$route.query.modal_video_id
    }
    if (this.$route.query.keyword) {
      this.keyword = this.$route.query.keyword
    }
    if (this.$route.query.asset_id) {
      if (this.$route.query.page_index) {
        this.pageIndex = parseInt(this.$route.query.page_index ?? 0, 10)
      }
      // if (this.$route.query.page_token) {
      //   this.pageToken = this.$route.query.page_token
      // }
      this.assetId = this.$route.query.asset_id
    }
  },
  methods: {
    onChangeVideoId(videoId) {
      this.videoId = videoId
      this.keyword = ''
      const query = { ...this.$route.query }
      if (videoId === '') {
        delete query.video_id
      } else {
        query.video_id = videoId
      }
      query.type = 1
      delete query.asset_id
      delete query.keyword
      delete query.page_index
      this.$router.push({ name: 'youtube-claims-search-index', query }, () => {})
    },
    onChangeKeyword(keyword) {
      // this.keyword = keyword
      // this.videoId = ''
      const query = { ...this.$route.query }
      delete query.video_id
      delete query.page_index
      query.type = 2
      if (keyword === '') {
        delete query.keyword
      } else {
        query.keyword = keyword
      }
      this.$router.push({ name: 'youtube-claims-search-index', query }, () => {})
    },
    onSelectAsset(assetId) {
      // this.assetId = assetId
      const query = { ...this.$route.query }
      delete query.video_id
      delete query.page_index
      query.type = 2
      if (assetId === '') {
        delete query.asset_id
      } else {
        query.asset_id = assetId
      }
      this.$router.push({ name: 'youtube-claims-search-index', query }, () => {})
    },
    onChangePagination(pageInfo) {
      const { pageIndex } = pageInfo
      const query = { ...this.$route.query }
      // query.page_token = nextPageToken
      query.page_index = pageIndex
      this.pageIndex = pageIndex
      this.$router.push({ name: 'youtube-claims-search-index', query }, () => {})
    },
    onClaimRowClicked(id) {
      this.modalVideoId = id
      const query = { ...this.$route.query }
      query.modal_video_id = id
      this.$router.push({ name: 'youtube-claims-search-index', query }, () => {})
    },
    onDetailClosed() {
      this.modalVideoId = null
      const query = { ...this.$route.query }
      delete query.modal_video_id
      this.$router.push({ name: 'youtube-claims-search-index', query }, () => {})
    },
  },
}
</script>

<style scoped>
.error-message {
  color: #ff0000;
  font-size: 16px;
  margin: 20px auto 120px 20px;
  text-align: left;
}
</style>
